export const setCookie = (
  name: string,
  value: string | number,
  days?: number
): void => {
  let expires = ''
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = `; expires=${date.toUTCString()}`
  }
  document.cookie = `${name}=${value || ''}${expires}; path=/`
}

export const getCookie = (name: string): string | null => {
  const nameEQ = `${name}=`
  const cookies = document.cookie.split(';') || []

  const cookie = cookies
    .find(c => c.trimStart().indexOf(nameEQ) === 0)
    ?.trimStart()
  return cookie ? cookie.substring(nameEQ.length, cookie.length) : null
}
